import axios from 'Utils/cj-axios'
import cjv3Axios from 'Utils/cjv3-axios'

export const getZnsTemplateByIdNew = async () => {
  const resp = await cjv3Axios.get(`/v1/zns/templates`)
  if (!resp.data) {
    throw resp
  }
  return { data: resp.data }
}

export const getParameterSegment = async () => {
  const resp = await axios.get(`/customer-journeys/parameters`)
  if (!resp.data) {
    throw resp
  }
  return { data: resp.data }
}
